<div class="ep">
  <button
    type="button"
    class="ep-trigger"
    [class.is-open]="open"
    aria-label="Insert emoji"
    title="Emoji"
    aria-haspopup="dialog"
    [attr.aria-expanded]="open"
    (click)="toggle()">
    <i class="fa fa-smile-o"></i>
  </button>

  @if (open) {
    <div class="ep-panel" role="dialog" aria-label="Emoji picker">
      <div class="ep-tabs" role="tablist">
        @for (category of categories; track category.id; let i = $index) {
          <button
            type="button"
            role="tab"
            class="ep-tab"
            [class.is-active]="i === activeIndex"
            [attr.aria-selected]="i === activeIndex"
            [attr.aria-label]="category.label"
            [title]="category.label"
            (click)="selectCategory(i)">
            {{ category.icon }}
          </button>
        }
      </div>

      <div class="ep-grid">
        @for (emoji of categories[activeIndex].emojis; track emoji) {
          <button type="button" class="ep-emoji" (click)="pick(emoji)">{{ emoji }}</button>
        }
      </div>

      <p class="ep-caption">{{ categories[activeIndex].label }}</p>
    </div>
  }
</div>
